import Vue from 'vue';

import {formatDate} from './formatters';

function insertDelimeters(v:number, n:number, x?:number) {
    const re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return v.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
}
export function roundPrice(num:number){
    if(('' + num).indexOf('e')===-1) {
        return +(Math.round(parseFloat(num + 'e+' + 2))  + 'e-' + 2);
    } else {
        const arr = ('' + num).split('e');
        let sig = '';
        if(+arr[1] + 2 > 0) {
            sig = '+';
        }
        return +(Math.round(parseFloat(+arr[0] + 'e' + sig + (+arr[1] + 2))) + 'e-' + 2);
    }
}
export function addDays(orig: Date, days:number) {
    const dat = new Date(orig.valueOf());
    dat.setDate(dat.getDate() + days);
    return dat;
}

Vue.filter('roundNumber', function(v:number) {
    const result = insertDelimeters(roundPrice(v), 2);
    return result;
});
Vue.filter('formatPrice', function(v:any) {
    if (isNaN(v) || v==='') {return '';};
    const result = '$' + insertDelimeters(roundPrice(v), 2);
    return result;
});
Vue.filter('formatPriceRound', function(v:any) {
    if (isNaN(v) || v==='') {return '';};
    const result = '$' + insertDelimeters(roundPrice(v), 0);
    return result;
});
Vue.filter('formatPriceCr', function(v:number) {
    // const suf = ( v<0) ? ' DR' : ' CR';
    const result = '$' + insertDelimeters(roundPrice(Math.abs(v)), 2);
    return result;
});

export function fixUtcFormat(dateStr: any ) {
    if (dateStr.indexOf('Date') >= 0) return extractJsonDate(dateStr);
    return ((typeof dateStr !== 'string') || dateStr.endsWith('Z')) ? dateStr : dateStr + 'Z';
}

Vue.filter('formatDate', formatDate);

Vue.directive('visible', (el, binding) => {
    const value = binding.value;

    if (value) {
        el.style.visibility = 'visible';
    } else {
        el.style.visibility = 'hidden';
    }
});


// Vue.directive('tooltip', {
//     inserted(el){
//         (window.$ && $(el)as any ).tooltip({
//             content () {
//                 return $(this).prop('title');
//             }
//         });
//     },
//     componentUpdated(el){
//         (window.$ && $(el)as any ).tooltip({
//             content () {
//                 return $(this).prop('title');
//             }
//         });
//     }
// });



// import VueWin from '@hscmap/vue-window'
// Vue.use(VueWin);
// import VueGoodTable from 'vue-good-table';
// Vue.use(VueGoodTable);

// import Vuelidate from 'vuelidate'
// Vue.use(Vuelidate)
import * as uiv from 'uiv';
Vue.use(uiv, {prefix: 'uiv'});
import Vuex from 'vuex'

Vue.use(Vuex)
// import money from 'v-money';
// Vue.use(money, {precision: 2});

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import { ClientTable, Event} from 'vue-tables-2';
import { extractJsonDate } from '@/common/utils';
Vue.use(ClientTable);
